import { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import { getRecentJobs, putJobStatus } from "../../../services/JobService";

import JobsTable from "../../../components/CustomTable/JobsTable";

const useStyles = makeStyles({
  root: {},
});

const toggleButtons = [
  { title: "Active", value: "active", color: "primary" },
  { title: "Inactive", value: "inactive", color: "error" },
];

export default function ContactUs() {
  const classes = useStyles();
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("active");
  const [loadingRecentJobs, setLoadingRecentJobs] = useState(false);
  const [recentJobs, setRecentJobs] = useState([]);

  const filteredJobs = useMemo(() => {
    return recentJobs.filter(
      (item) =>
        selectedStatusFilter === "" ||
        (selectedStatusFilter === "inactive" && item.JOB_STATUS === null) ||
        (selectedStatusFilter === "active" && Boolean(item.JOB_STATUS))
    );
  }, [recentJobs, selectedStatusFilter]);

  const retrieveRecentJobs = useCallback(async () => {
    try {
      setLoadingRecentJobs(true);
      const res = await getRecentJobs();
      setRecentJobs(res);
    } catch (e) {
      console.error(e);
      toast.error("Unexpected error occurs while loading foremen table data!");
    } finally {
      setLoadingRecentJobs(false);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    retrieveRecentJobs().then(() => {
      if (!isMounted) return;
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const handleStatusFilterChange = (e) => {
    setSelectedStatusFilter(e.target.value);
  };

  const handleUpdate = () => {
    retrieveRecentJobs();
  };

  const handleActivate = (rowData) => {
    try {
      setLoadingRecentJobs(true);
      putJobStatus(rowData).then((res) => {
        if (res.status === 200) {
          setLoadingRecentJobs(true);
          toast.success("Job status updated successfully!");
          retrieveRecentJobs();
        }
      });
    } catch (e) {
      console.error(e);
      toast.error("Unexpected error occurs while updating job status!");
    } finally {
      setLoadingRecentJobs(false);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <ToggleButtonGroup
                size="small"
                aria-label="Status"
                value={selectedStatusFilter}
                onChange={handleStatusFilterChange}
                exclusive
              >
                <ToggleButton value="">All</ToggleButton>
                {toggleButtons.map((button) => (
                  <ToggleButton
                    key={button.value}
                    color={button.color}
                    value={button.value}
                  >
                    {button.title}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <JobsTable
            title="Jobs"
            loading={loadingRecentJobs}
            items={filteredJobs}
            // handleUpdate={handleUpdate}
            // handleActivate={handleActivate}
          />
        </Grid>
      </Grid>
    </div>
  );
}
